import { ReactNode } from "react";

import { Drawer, DrawerContent, DrawerOverlay } from "@chakra-ui/react";
import { useStakeProvider } from "dapp-sdk";

export interface PageLayoutProps {
  Sidebar: ReactNode;
  MobileSideBar: ReactNode;
  Header: ReactNode;
  children: ReactNode;
}

const PageLayout = ({
  Sidebar,
  Header,
  children,
  MobileSideBar,
}: PageLayoutProps) => {
  const { setMobileMenuVisible, isMobileMenuOpen } = useStakeProvider();

  return (
    <>
      {Sidebar && Sidebar}
      {MobileSideBar && (
        <Drawer
          isOpen={isMobileMenuOpen}
          placement="left"
          onClose={() => setMobileMenuVisible(false)}
          returnFocusOnClose={false}
          onOverlayClick={() => setMobileMenuVisible(false)}
        >
          <DrawerOverlay bg="modalOverlay" />
          <DrawerContent bg="backgroundSecondary">
            {MobileSideBar}
          </DrawerContent>
        </Drawer>
      )}
      {Header && Header}
      {children}
    </>
  );
};

export default PageLayout;
